import React from "react";
import AppSelect from "../AppSelect/AppSelect";


/**
 * Choisit le format PDF ou CSV d'un document à produire.
 * @param {object} props
 * @param {string} [props.id]
 * @param {string} [props.value]
 * @param {(id: string, value: string) => void} [props.onValueChanged]
 * @param {boolean} [props.isDarkStyle]
 * @param {object} props.I18n
 * @param {(key: string) => string} props.I18n.get
 */
export default function DocumentFormatSelector(props) {
    const {
        id = "documentFormat",
        value = "PDF",
        onValueChanged,
        isDarkStyle = false,
        I18n
    } = props;

    return (
        <AppSelect
            id={id}
            label={I18n.get("Select document format")}
            allowEmpty={false}
            defaultValue={value}
            onValueChanged={onValueChanged}
            showIcon={true}
            icons={{
                PDF:["fas" , "file-pdf"],
                CSV:["fas" , "file-csv"]
            }}
            isDarkStyle={isDarkStyle}
            options={[
                "PDF",
                "CSV"
            ]}
            I18n={I18n}
        />
    );
}
